import { Component } from '@angular/core';
import { UserService } from '../demo/service/user.service';
import { Router } from '@angular/router';
import { Company } from '../demo/domain/company';
import { CompanyService } from '../demo/service/company.service';
import { LoginService } from '../demo/service/login.service';
import { MessageService } from 'primeng/api';


@Component({
  selector: 'app-login',
  templateUrl: './app.login.component.html',
})
export class AppLoginComponent {
    constructor(private userService: UserService,
                private companyService: CompanyService,
                private loginService: LoginService,
                private messageService: MessageService,
                private router: Router) {

        this.companyService.get().then(objects => this.companies = objects);
    }

    korisnik: string;

    zaporka: string;

    companies: Company[];

    company: Company;
    isLoading: boolean;

    loginClick() {
        this.isLoading = true;
        this.loginService.login(this.korisnik, this.zaporka)
            .subscribe(() => {
                this.isLoading = false;
                this.router.navigate(['/reportdefinitions']);
            }, error => {
                if (error.status === 400) {

                    this.messageService.add({ 
                        severity: 'error', 
                        summary: 'Login error', 
                        detail: 'Unauthorized: Incorrect username or password.' 
                    });
                } else {
                    // Handle other errors

                    this.messageService.add({ 
                        severity: 'error', 
                        summary: 'Login error', 
                        detail: error.status + ': ' + error.message 
                    });
                }
                this.isLoading = false;
                console.log("Error1", error);
            });
    }

    onKeydown(event: KeyboardEvent) {
        if ( event.key === 'Enter' ) {
            this.loginClick();
        }
    }


}
